import React, { useEffect } from "react";
import { Loading } from "react-native-web-ui-components";

const BookingRedirectScreen = () => {
  useEffect(() => {
    window.location.href = "https://digireadbooking.vercel.app/";
  }, []);

  return <Loading />;
};

export default BookingRedirectScreen;